import { createReducer } from '@reduxjs/toolkit';

import { SYNC_INITIAL_STATE, SYNC_STORE_NAME } from './sync.state';
import {
  CREATE_SYNC_FAILURE,
  CREATE_SYNC_REQUEST,
  CREATE_SYNC_SUCCESS,
  FETCH_SYNC_FAILURE,
  FETCH_SYNC_REQUEST,
  FETCH_SYNC_SUCCESS,
  RESET_SYNC_STATE,
} from './sync.action';

export const syncReducer = createReducer(SYNC_INITIAL_STATE, (builder) => {
  builder
    .addCase(RESET_SYNC_STATE, () => SYNC_INITIAL_STATE)
    .addCase(CREATE_SYNC_REQUEST, (state) => ({
      ...state,
      loading: true,
    }))
    .addCase(CREATE_SYNC_SUCCESS, (state, action: any) => ({
      ...state,
      loading: false,
      error: null,
      syncs: [
        ...state.syncs.filter((s) => s.connectionUuid != action.payload.connectionUuid),
        {
          status: 'inProgress',
          connectionUuid: action.payload.connectionUuid,
          requestId: action.payload.requestId,
          dataType: action.payload.dataType,
        },
      ],
    }))
    .addCase(CREATE_SYNC_FAILURE, (state, action: any) => ({
      ...state,
      loading: false,
      error: action.payload,
    }))
    .addCase(FETCH_SYNC_FAILURE, (state, action: any) => ({
      ...state,
      loading: false,
      error: action.payload,
    }))
    .addCase(FETCH_SYNC_REQUEST, (state) => ({
      ...state,
      loading: true,
    }))
    .addCase(FETCH_SYNC_SUCCESS, (state, action: any) => ({
      ...state,
      loading: false,
      error: null,
      syncs: action.payload.map((res: any) =>
        res.status == 'fulfilled'
          ? {
              connectionUuid: res.value.meta.connectionUuid,
              status: res.value.data.status,
              dataType: res.value.data.dataType,
            }
          : {
              status: 'error',
              connectionUuid: res.reason?.message[0]?.split('connectionUuid')?.[1]?.trim(),
              dataType: res.reason?.message[0]?.split('dataType')?.[1]?.trim()?.split(' ')?.[0],
            },
      ),
    }));
});

export const syncReducerConfig = {
  [SYNC_STORE_NAME]: syncReducer,
};
